import * as React from 'react';
import { IInvoiceItem } from '../../../../Models/Invoice/IInvoiceItem';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { AddRegistrationToInvoiceView } from './AddRegistrationToInvoiceView';
import * as Services from '../../../../Services/Services';
import { IEventTypeApi } from '../../../../Services/API/EventType/IEventTypeApi';
import { IEventType } from '../../../../Models/EventTypes/IEventType';
import { IEventApi } from '../../../../Services/API/Event/IEventApi';
import { IEventItem } from '../../../../Models/Event/IEventItem';
import { IAttendeeRegistrationListItem, IAttendeeRegistrationListItemSelected } from '../../../../Models/Event/IAttendeeRegistrationListItem';
import { IAppStore } from '../../../../Stores/IAppStore';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { IUserProfile } from '../../../../Models/Profile/IUserProfile';
import { connect } from 'react-redux';
import { EventTypeEnum } from '../../../../Models/Event/EventTypeEnum';


interface IAddRegistrationToInvoiceProps {
    item: IInvoiceItem;
    saveItems: (item: IInvoiceItem[]) => void;
    close: () => void;
    isVisible: boolean;
    isReadOnly: boolean;
    propertyChanged: (key: string, value: any) => void;
    isLoading: boolean;
    statusMessage?: IStatusMessage;
    profile: IUserProfile;
}


export const AddRegistrationToInvoice: React.FunctionComponent<IAddRegistrationToInvoiceProps> = (props) => {
    const [eventTypeSelected, setEventTypeSelected] = React.useState<number>();
    const [eventSelected, setEventSelected] = React.useState<number>();
    const [name, setName] = React.useState<string>();
    const [registrations, setRegistrations] = React.useState<IAttendeeRegistrationListItem[]>([])
    const [itemInvoiceSelected, setItemInvoiceSelected] = React.useState<IAttendeeRegistrationListItemSelected[]>([]);
    const [eventTypes, setEventTypes] = React.useState<IEventType[]>([]);
    const [events, setEvents] = React.useState<IEventItem[]>([]);

    const loadEventTypes = async () => {
        const eventTypeApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const result = await eventTypeApi.getEventTypes(false);
        if (result.isSuccess && result.data) {

            setEventTypes(result.data);
        }
    }

    const loadEvents = async (evetType: number) => {
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventApi.getEventByFilterQuery(undefined, evetType, undefined, undefined, undefined, EventTypeEnum.Lessons);
        if (result.isSuccess && result.data) {

            setEvents(result.data);
        }
    }

    const loadRegistration = async (eventTypeSelected?: number, eventSelected?:number, name?:string) => {
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventApi.findRegistration(eventTypeSelected, eventSelected, name);
        if (result.isSuccess && result.data) {
            setRegistrations(result.data);
        }
    }

    React.useEffect(() => {
        loadEventTypes();
    }, []);

    React.useEffect(() => {

        if (eventTypeSelected && eventTypeSelected > 0) {
            loadEvents(eventTypeSelected);
        }
    }, [eventTypeSelected])


    React.useEffect(() => {
        if ((eventTypeSelected && eventTypeSelected > 0) || (eventSelected && eventSelected > 0) || (name && name!=""))
        loadRegistration(eventTypeSelected, eventSelected, name);
         
    }, [eventTypeSelected, eventSelected,name])

    React.useEffect(() => {
        setItemInvoiceSelected(registrations.map(item => {
            return {
                ...item,
                priceInvoiceSelected: false,
                priceFirstSemesterInvoiceSelected: false,
                priceSecondSemesterInvoiceSelected: false,
                canCreatePriceInvoice: item.price > (item.priceInvoiceTotal ? item.priceInvoiceTotal : 0),
                canCreateFirstPriceInvoice: item.firstSemesterPrice > (item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0),
                canCreateSecondPriceInvoice: item.secondSemesterPrice > (item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0)
            }
        }));
    }, [registrations])

    const eventSelectedChaged = (id?: number) => {
        setEventSelected(id);
    }

    const eventTypeSelectedChaged = (id?: number) => {
        setEventTypeSelected(id);
    }

    const nameSelectedChaged = (name?: string) => {
        setName(name);
    }

    const InvoiceAllSelection = (selectFa: keyof IAttendeeRegistrationListItemSelected, fieldName: string, value: boolean) => {
        let new_array = itemInvoiceSelected.map(element => element[selectFa] === true ? { ...element, [fieldName]: value } : element);
        setItemInvoiceSelected(new_array);
    }

    const InvoiceSelection = (registrationId: number, fieldName: string, value: boolean) => {
        let new_array = itemInvoiceSelected.map(element => element.id == registrationId ? { ...element, [fieldName]: value } : element);
        setItemInvoiceSelected(new_array);
    }

    const GetIInvoiceItem = (item:IAttendeeRegistrationListItem, price: number,semester:number): IInvoiceItem => {
        return {
            registrationId: item.id,
            itemName: item.eventName,
            itemId: item.eventId,
            price: price,
            vat: 0,
            orderId: item.orderId,
            amount: 1,
            semester: semester,
            total: 0, totalVat: 0, totalWithVat: 0, id: 0
        }
    }

    const saveItems = () => {
        const invoiceItems: IInvoiceItem[] = [];
        for (let i = 0; i < itemInvoiceSelected.length; i++) {
            const item = itemInvoiceSelected[i];
            if (item.priceInvoiceSelected) {
                invoiceItems.push(GetIInvoiceItem(item, item.price - (item.priceInvoicePaidTotal ? item.priceInvoicePaidTotal : 0),0));
            }
            if (item.priceFirstSemesterInvoiceSelected) {
                invoiceItems.push(GetIInvoiceItem(item, item.firstSemesterPrice - (item.firstSemesterPriceInvoiceTotal ? item.firstSemesterPriceInvoiceTotal : 0),1));
            }
            if (item.priceSecondSemesterInvoiceSelected) {                
                invoiceItems.push(GetIInvoiceItem(item, item.secondSemesterPrice - (item.secondSemesterPriceInvoiceTotal ? item.secondSemesterPriceInvoiceTotal : 0),2));
            }
        }
        props.saveItems(invoiceItems);
    }

    return (<AddRegistrationToInvoiceView
        registrations={itemInvoiceSelected}
        setEventSelected={eventSelectedChaged}
        setEventTypeSelected={eventTypeSelectedChaged}
        setTextSelected={nameSelectedChaged}
        events={events}
        eventTypes={eventTypes}
        item={props.item}
        saveItems={saveItems}
        close={props.close}
        isVisible={props.isVisible}
        isReadOnly={props.isReadOnly}
        isLoading={props.isLoading}
        statusMessage={props.statusMessage}
        propertyChanged={props.propertyChanged}
        invoiceAllSelection={InvoiceAllSelection}
        invoiceSelection={InvoiceSelection}
        profile={props.profile}
    />)
}

const AddRegistrationToInvoiceToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,


});

const AddRegistrationToInvoiceToDispatchProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(AddRegistrationToInvoiceToProps, AddRegistrationToInvoiceToDispatchProps)(AddRegistrationToInvoice);

